export default function MoonIcon({ className = "w-6 h-6" }) {
  return (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 15.2021C19.0491 15.5984 18.0289 15.8018 16.9987 15.8004C12.6912 15.8004 9.19955 12.3088 9.19955 8.00128C9.19955 6.93739 9.41233 5.9239 9.79789 5C8.37681 5.59283 7.16294 6.59291 6.30916 7.8743C5.45538 9.15568 4.99987 10.6611 5 12.2008C5 16.5084 8.49163 20 12.7992 20C14.3389 20.0001 15.8443 19.5446 17.1257 18.6908C18.4071 17.8371 19.4072 16.6232 20 15.2021Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
